export default {
  meta: {
    title: '商场初筛',
  },
};
